import { useRef, useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getTCAPUsers from '@/API/TCAPUser/getTCAPUsers';
import {
    newTableMap,
    userSynced,
} from '@/pages/accounts/resourceAccounts/table';

const useGetTCAPUsers = (
    currentCompany,
    setHasNoUsers,
    setTableData,
    gridRef,
    setSummaryData,
) => {
    const setHasNoUsersRef = useRef(setHasNoUsers);
    setHasNoUsersRef.current = setHasNoUsers;

    const setTableDataRef = useRef(setTableData);
    setTableDataRef.current = setTableData;

    const setSummaryDataRef = useRef(setSummaryData);
    setSummaryDataRef.current = setSummaryData;

    const query = useQuery({
        queryKey: ['users'],
        queryFn: () => getTCAPUsers(currentCompany),
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: !!currentCompany,
    });

    // Drive state from query.data via useEffect so React Query deduplication
    // across rapid remounts doesn't leave the table blank.
    useEffect(() => {
        if (!query.data) return;
        const newTable = newTableMap(query.data.tcapUsers).map((user) => ({
            ...user,
            displayName:
                user.displayName ||
                user.primaryUser?.displayName ||
                [user.primaryUser?.givenName, user.primaryUser?.surname]
                    .filter(Boolean)
                    .join(' ') ||
                user.primaryUser?.userPrincipalName ||
                '',
        }));
        if (!query.data.tcapUsers.length) {
            userSynced(currentCompany, setHasNoUsersRef.current);
        }
        setTableDataRef.current((prev) => ({
            ...prev,
            data: newTable,
        }));
        setSummaryDataRef.current(query.data);
        gridRef?.current?.api?.applyColumnState({
            state: [{ colId: 'displayName', sort: 'asc' }],
        });
    }, [query.data, currentCompany, gridRef]);

    return query;
};

export default useGetTCAPUsers;
